import { moveIndex } from './overlayCore';

/**
 * Keyboard model for an inline radio group inside ui/Menu (T-53: the appearance
 * row "מראה: מערכת · בהיר · כהה"). The group is one row of `menuitemradio`s:
 *  - ↑ / ↓ treat the row as one stop and land on its checked choice;
 *  - ← / → move between the choices of the row (visual order, wraps).
 * `groups[i]` is the group id of item i (undefined for a plain item).
 */

export function verticalStep(
  dir: 'next' | 'prev',
  active: number,
  disabled: boolean[],
  groups: (string | undefined)[],
  checked: boolean[],
): number {
  const own = groups[active];
  let i = active;
  // Leave the current row (bounded: the list may be all one group).
  for (let guard = 0; guard < groups.length; guard++) {
    const next = moveIndex(dir, i, disabled);
    if (next < 0) return active;
    i = next;
    if (!own || groups[i] !== own || i === active) break;
  }
  const landed = groups[i];
  if (!landed || landed === own) return i;
  const choice = groups.findIndex((g, k) => g === landed && checked[k] && !disabled[k]);
  return choice >= 0 ? choice : i;
}

export function groupStep(
  forward: boolean,
  active: number,
  disabled: boolean[],
  groups: (string | undefined)[],
): number {
  const own = groups[active];
  if (!own) return active;
  const members = groups.map((g, k) => (g === own && !disabled[k] ? k : -1)).filter((k) => k >= 0);
  const at = members.indexOf(active);
  if (at < 0 || members.length < 2) return active;
  return members[(at + (forward ? 1 : -1) + members.length) % members.length];
}
